import styled, { css } from 'styled-components/macro'
import { mq, ScreenSize } from 'styles/mq'

export const containerStyle = css`
  padding: 0 var(--container-spacing);
  width: 100%;
  max-width: ${ScreenSize.LG / 10}rem;
  margin: 0 auto;
`

export const Container = styled.div`
  ${containerStyle}
`
